import { render, staticRenderFns } from "./DadosTomador.vue?vue&type=template&id=5b483be5&scoped=true"
import script from "./DadosTomador.vue?vue&type=script&lang=js"
export * from "./DadosTomador.vue?vue&type=script&lang=js"
import style0 from "./DadosTomador.vue?vue&type=style&index=0&id=5b483be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b483be5",
  null
  
)

export default component.exports